import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider as ReduxProvider } from "react-redux";
import { I18nextProvider } from "react-i18next";
import "./index.css";

import i18n from "./i18n";
import configureStore from "./redux/configureStore";
import AppContiner from "./AppContiner";
import * as serviceWorker from "./serviceWorker";
import Loader from "./components/common/Loader";
import { pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
const store = configureStore();

ReactDOM.render(
  // <React.StrictMode>
  <Suspense fallback={<Loader />}>
    <ReduxProvider store={store}>
      <Router>
        <I18nextProvider i18n={i18n}>
          <AppContiner />
        </I18nextProvider>
      </Router>
    </ReduxProvider>
  </Suspense>,
  // </React.StrictMode>,

  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
